import React from "react";
import { Row, Col } from "reactstrap";
import { connect } from "react-redux";
import { AlternativeAppBtn, Intl } from "components";
import SettingsActions from "store/reducers/Settings";

const Footer = ({ locale, switchLanguage, toggleLoading, user, pathname }) => (
  <>
    <footer>
      <Row>
        <Col sm={6}>
          <div className="text-xxsm locale-selector">
            {locale ? <Intl id={locale.name} /> : <Intl id="english" />}
            <div className="locale-selector-options">
              {locale && locale.name === "english" ? (
                <span
                  className="ml-3"
                  onClick={() => {
                    switchLanguage({
                      locale: "es",
                      name: "spanish",
                    });
                    toggleLoading(true);
                    setTimeout(() => {
                      window.location.reload();
                    }, 500);
                  }}
                >
                  <Intl id="spanish" />
                </span>
              ) : (
                <span
                  className="ml-3"
                  onClick={() => {
                    switchLanguage({
                      locale: "en",
                      name: "english",
                    });
                    toggleLoading(true);
                    setTimeout(() => {
                      window.location.reload();
                    }, 500);
                  }}
                >
                  <Intl id="english" />
                </span>
              )}
            </div>
          </div>
        </Col>
        <Col sm={6}>
          {user && user.access_token ? (
            <div className="text-xxsm text-right">
              <AlternativeAppBtn
                className="footer-switch-app"
                token={user && user.access_token ? user.access_token : ""}
                refreshtoken={
                  user && user.refresh_token ? user.refresh_token : ""
                }
                target="_blank"
                rel="noopener noreferrer"
                text
                appSelectorAlternativeUrl={
                  process.env.REACT_APP_ALTERNATIVE_APP_URL || ""
                }
                language={locale.locale}
              >
                <Intl id="open" />
              </AlternativeAppBtn>
            </div>
          ) : (
            pathname !== "/auth/select-app" &&
            !pathname.includes("/auth/recover-password/") && (
              <div className="copyright text-right text-gray-7">
                &copy;
                {' '}
                {new Date().getFullYear()}
                {' '}
                {`massphoning (${process.env.IMAGE_VERSION})`}
              </div>
            )
          )}
        </Col>
      </Row>
    </footer>
  </>
);

const mapStateToProps = ({ settings, user }) => ({
  user,
  locale: settings.locale,
});

const mapDispatchToProps = {
  switchLanguage: SettingsActions.switchLanguage,
  toggleLoading: SettingsActions.toggleLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
